<template>
    <div>
    <card-dashboard 
        id="card-projetos-cadastrados"
        bg-variante="primary" 
        icone="fa-solid fa-file-invoice-dollar" 
        titulo="" 
        :valor="valor"
        titulo-modal="Projetos cadastrados"
        :colunas="colunas"
        :dados="dados"
    >
        <template #titulo>
            <span>
                Projetos<br/>cadastrados
            </span>
        </template>
    </card-dashboard>
    </div>
</template>
<script>
import CardDashboard from "@/components/card/CardDashboard";
import DashboardAdminService from "@/common/services/dashboards/dashboard_admin.service";
export default {
    components : {
        CardDashboard
    },
    mounted(){
        this.buscarDados();
    },
    data : () => ({
        valor : 0,
        colunas : [
            { key : "codigo",  label : "Código do projeto"},
            { key : "titulo",  label : "Titulo"}
        ],
        dados : [],
    }),
    methods : {
        buscarDados(){
            DashboardAdminService.projetosCadastrados().then(response => {
                this.dados = response.data.data;
                this.valor = response.data.data.length;
            });
        },

    }
    
}
</script>
<style lang="">
    
</style>